export const UPDATE_BOOKKEEPING_ACCOUNT = 'update-bookkeeping-account'

export type BookkeepingAccount = {
    accountNo: string,
    name: string,
    active: boolean,
    description: string,
    keywords: string[],
    vatSuggestionId: number,
    isAccrual: boolean
}